(ns superadmin.announcements.queries
  (:require [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn announcements-query
  "Query for fetching all announcements for superadmin."
  []
  #js {:queryKey #js ["superadmin-announcements"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/announcements {})))})

(defn create-announcement-mutation
  "Mutation for creating a new announcement."
  []
  #js {:mutationKey #js ["create-announcement-mutation"]
       :mutationFn (fn [{:keys [title content routes]}]
                     (qhttp/post (qhttp/render :superadmin-api/announcements {})
                                 {:body (cond-> {:title title
                                                 :content content}
                                          (seq routes) (assoc :routes routes))}))
       :onSuccess (fn []
                    (rf/dispatch [:ocp/close])
                    (rf/dispatch [:toaster-bus/add {:type :success
                                                    :message "Announcement created successfully."}])
                    (invalidate-queries {:queryKey ["superadmin-announcements"]}))
       :onError (fn [_data]
                  (rf/dispatch [:toaster-bus/add {:type :error
                                                  :message "Failed to create announcement."}]))})

(defn update-announcement-mutation
  "Mutation for updating an announcement (e.g., toggling isActive)."
  [id]
  #js {:mutationKey #js ["update-announcement-mutation" id]
       :mutationFn (fn [{:keys [isActive]}]
                     (qhttp/patch (qhttp/render :superadmin-api/announcement {:id id})
                                  {:body {:isActive isActive}}))
       :onSuccess (fn [^js updated-announcement]
                    (let [is-active (.-isActive updated-announcement)]
                      (rf/dispatch [:toaster-bus/add {:type :success
                                                      :message (if is-active
                                                                 "Announcement enabled."
                                                                 "Announcement disabled.")}]))
                    (invalidate-queries {:queryKey ["superadmin-announcements"]}))
       :onError (fn [_data]
                  (rf/dispatch [:toaster-bus/add {:type :error
                                                  :message "Failed to update announcement."}]))})
